// extracted by mini-css-extract-plugin
export default {"container":"TotalSampleSize_container__yAVT8","input":"TotalSampleSize_input__f4cnE"};